/* CAFFREY Eleganza Noire — page behaviour (launch build, Claude Code, 2026-10-06).
   <cf-en-product>  · size select (nothing preselected) → price, Add to cart state, ?variant= URL; the select's own
                      bubbling change event also updates the kit sticky bar and Shopify's Shop Pay button.
                    · "Choose your size" check: Add to cart, the sticky bar's Add to cart, Shop Pay and every link to
                      #NoireSize bring the shopper to the size menu, focus it and announce "Choose your size"
                      (role=status). No cart request is sent without a size.
                    · quantity stepper; gallery thumbnails swap srcset + sizes (never one full-size file).
                    · kit sticky bar: with no size chosen it reads "Choose your size" and keeps an active
                      "Add to cart" (the kit treats "no variant" as unavailable); with a size it shows "Men’s 9".
   [data-noire-reveal] fades the stage close-up and the study pins in once (skipped with prefers-reduced-motion).
   [data-noire-defer] holds below-the-fold images until the hero (LCP) image has loaded.
   No dependencies. Uses Dawn's <product-form> (product-form.js) for the AJAX add when present. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!customElements.get('cf-en-product')) {
    class CfEnProduct extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.form = document.getElementById(this.dataset.form);
        this.select = document.getElementById(this.dataset.select);
        if (!this.form || !this.select) return;
        var self = this;
        this.form.noValidate = true;
        this.atc = this.form.querySelector('[data-cf-atc]');
        this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
        this.msg = this.querySelector('[data-noire-msg]');
        this.price = this.querySelector('[data-noire-price]');
        this.qty = this.form.querySelector('[name="quantity"]');
        this.anyAvailable = Array.prototype.some.call(this.select.options, function (o) {
          return o.value && o.getAttribute('data-available') === 'true';
        });

        this.sizeChoices = this.querySelector('[data-noire-size-choices]');
        this.sizeControl = this.querySelector('.cf-en-size__control');
        if (this.sizeChoices && this.sizeControl) {
          this.sizeChoices.hidden = false;
          this.sizeControl.hidden = true;
        }
        this.select.addEventListener('change', function () { self.update(true); });
        this.addEventListener('click', function (e) {
          var sizeButton = e.target.closest('[data-noire-variant]');
          if (sizeButton && !sizeButton.disabled) {
            self.select.value = sizeButton.dataset.noireVariant;
            self.select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var b = e.target.closest('[data-noire-qty]');
          if (b) self.step(Number(b.getAttribute('data-noire-qty')));
        });
        // Capture at the document so this runs before Dawn's <product-form> submit handler on the form itself.
        document.addEventListener('submit', function (e) { if (e.target === self.form) self.validate(e); }, true);
        var pay = this.querySelector('[data-noire-pay]');
        if (pay) {
          pay.addEventListener('click', function (e) {
            if (self.select.value) return;
            e.preventDefault();
            e.stopPropagation();
            self.ask();
          }, true);
        }
        document.addEventListener('click', function (e) {
          var a = e.target.closest('a[href="#' + self.select.id + '"], [data-noire-choose]');
          if (!a) return;
          e.preventDefault();
          if (self.select.value) self.reveal(self.sizeFocus()); else self.ask();
        });
        window.addEventListener('pageshow', function () { self.update(false); });
        this.gallery();
        this.update(false);
        this.watchSticky();
      }

      sizeFocus() {
        return this.querySelector('[data-noire-size-group]:not([hidden]) [data-noire-variant]:not(:disabled)') || this.select;
      }

      syncSizeButtons() {
        var value = this.select.value;
        this.querySelectorAll('[data-noire-variant]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.noireVariant === value)); });
      }

      chosen() {
        var o = this.select.selectedOptions && this.select.selectedOptions[0];
        return o && o.value ? o : null;
      }

      update(fromUser) {
        var o = this.chosen();
        if (o && this.price && o.getAttribute('data-price')) this.price.textContent = o.getAttribute('data-price');
        var ok = o ? o.getAttribute('data-available') === 'true' : this.anyAvailable;
        if (this.atc) {
          this.atc.disabled = !ok;
          if (this.atcLabel) this.atcLabel.textContent = ok ? this.dataset.add : this.dataset.sold;
        }
        if (o) this.clear();
        if (fromUser && o && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', o.value);
            history.replaceState(history.state, '', u.toString());
          } catch (err) { /* ignore */ }
        }
        this.syncSizeButtons();
        this.patchSticky();
      }

      step(delta) {
        if (!this.qty) return;
        this.qty.value = Math.max(1, (parseInt(this.qty.value, 10) || 1) + delta);
        this.qty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      validate(e) {
        if (this.qty && !(Number(this.qty.value) >= 1)) this.qty.value = 1;
        if (this.chosen()) { this.clear(); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        this.ask();
        var st = document.querySelector('cf-kit-sticky');
        if (st && typeof st.done === 'function') st.done();
      }

      ask() {
        if (this.msg) this.msg.textContent = this.dataset.choose;
        this.select.setAttribute('aria-invalid', 'true');
        this.reveal(this.sizeFocus());
      }

      reveal(el) {
        var r = el.getBoundingClientRect();
        if (r.top < 80 || r.bottom > window.innerHeight - 90) {
          el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        }
        try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
      }

      clear() {
        if (this.msg) this.msg.textContent = '';
        this.select.removeAttribute('aria-invalid');
      }

      gallery() {
        var frame = this.querySelector('[data-noire-frame]');
        var img = frame ? frame.querySelector('img') : null;
        var thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-noire-thumb]'));
        if (!img || thumbs.length < 2) return;
        thumbs.forEach(function (t) {
          t.addEventListener('click', function (e) {
            e.preventDefault();
            if (t.getAttribute('aria-current') === 'true') return;
            img.removeAttribute('fetchpriority');
            img.loading = 'eager';
            if (t.dataset.srcset) img.srcset = t.dataset.srcset; else img.removeAttribute('srcset');
            img.src = t.dataset.src;
            img.alt = t.dataset.alt || '';
            frame.setAttribute('data-shape', t.dataset.shape || 'hero');
            if (t.dataset.tile) frame.style.setProperty('--en-tile', t.dataset.tile); else frame.style.removeProperty('--en-tile');
            thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
            t.setAttribute('aria-current', 'true');
          });
        });
      }

      /* The kit sticky bar treats "no variant" as unavailable and shows the server's first variant title. With nothing
         preselected, show "Choose your size" and keep its "Add to cart" active: it clicks the main button, whose check
         leads the shopper to the size menu. With a size chosen, show the same label as the menu ("Men’s 9"). */
      watchSticky() {
        var self = this;
        var tries = 0;
        var attach = function () {
          var st = document.querySelector('cf-kit-sticky');
          if (!st) { if (++tries < 24) setTimeout(attach, 250); return; }
          if (self._stickyObs) return;
          self._sticky = st;
          self._stickyObs = new MutationObserver(function () { self.patchSticky(); });
          self._stickyObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          self.patchSticky();
        };
        attach();
      }

      patchSticky() {
        var st = this._sticky;
        if (!st) return;
        var btn = st.querySelector('[data-cf-sticky-atc]');
        var label = btn ? btn.querySelector('span') : null;
        var v = st.querySelector('[data-cf-sticky-variant]');
        var o = this.chosen();
        if (o) {
          var want = o.getAttribute('data-label') || '';
          if (v && want && v.textContent !== want) v.textContent = want;
          return;
        }
        if (!this.anyAvailable) return;
        if (btn && btn.disabled) btn.disabled = false;
        if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
        if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
      }
    }
    customElements.define('cf-en-product', CfEnProduct);
  }

  /* Reveal once on view (stage close-up fade; study pins in sequence). Elements already on screen show at once. */
  function reveal() {
    var els = document.querySelectorAll('[data-noire-reveal]');
    if (!els.length || reduced || !('IntersectionObserver' in window)) return;
    Array.prototype.forEach.call(els, function (el) {
      if (el.getAttribute('data-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return;
      el.setAttribute('data-reveal', 'pending');
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          el.setAttribute('data-reveal', 'done');
          io.disconnect();
        }
      }, { threshold: 0.15 });
      io.observe(el);
    });
  }
  /* Deferred images ([data-noire-defer]): below-the-fold images that sit inside the browser's lazy-load distance would
     otherwise download together with the hero (the LCP image) on a slow phone connection. They get their real
     srcset/src once the hero has loaded (then native lazy loading decides), or as soon as they come within 600 px of
     the viewport, whichever is first. Their boxes are reserved (width/height + aspect-ratio), so nothing shifts. */
  function deferred() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-noire-defer]'));
    if (!els.length) return;
    var go = function (el) {
      if (el._noireGo) return;
      el._noireGo = true;
      var nodes = el.matches('img') ? [el] : Array.prototype.slice.call(el.querySelectorAll('source, img'));
      nodes.forEach(function (n) {
        if (n.hasAttribute('data-srcset')) { n.setAttribute('srcset', n.getAttribute('data-srcset')); n.removeAttribute('data-srcset'); }
        if (n.hasAttribute('data-src')) { n.setAttribute('src', n.getAttribute('data-src')); n.removeAttribute('data-src'); }
      });
    };
    var all = function () { els.forEach(go); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { go(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '600px 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else { all(); return; }
    var hero = document.querySelector('.cf-en-frame__img');
    var after = function () { setTimeout(all, 200); };
    if (!hero || (hero.complete && hero.naturalWidth)) after();
    else { hero.addEventListener('load', after, { once: true }); hero.addEventListener('error', after, { once: true }); }
    setTimeout(all, 8000);
  }

  var start = function () { deferred(); reveal(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
